import { render } from "./StreakCategory.vue?vue&type=template&id=5150158c&scoped=true"
import script from "./StreakCategory.vue?vue&type=script&lang=js"
export * from "./StreakCategory.vue?vue&type=script&lang=js"

import "./StreakCategory.vue?vue&type=style&index=0&id=5150158c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5150158c"]])

export default __exports__